import React, {forwardRef} from 'react';
import {
    Button,
    Flex,
    Icon,
    PriorityIcon,
    Text,
    Title
} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import {ColumnsData} from '../../types';
import {INVENTORY_BUTTON_NAME, UNIT_FIELD_NAME} from '../../consts';
import texts from '../../texts';

interface Props {
    inventoryData: ColumnsData[];
    partName: string;
    isLoading: boolean;
    isOpen: boolean;
    onOpen: () => void;
}

export const InventoryInfo = forwardRef(
    ({inventoryData, partName, isLoading, isOpen, onOpen}: Props, ref) => {
        const unit = inventoryData?.find(col => col.columnName === UNIT_FIELD_NAME);
        const filteredList = inventoryData?.filter(col => col.columnName !== UNIT_FIELD_NAME);

        const handleShowInventory = () => {
            !isLoading && onOpen();
        };

        if (!isOpen) {
            return (
                <Flex justifyContent="flex-start" direction="column">
                    <Text skin="label-1">{texts.inventoryDetails}</Text>
                    <Button
                        name={INVENTORY_BUTTON_NAME}
                        inputRef={ref as React.RefObject<HTMLButtonElement>}
                        width="regularFixed"
                        size="large"
                        prefixIcon={
                            !isLoading && (
                                <Icon
                                    icon={PriorityIcon.showPasswordThin}
                                    iconColor="secondary-400"
                                />
                            )
                        }
                        skin="secondary"
                        onClick={handleShowInventory}
                    >
                        {isLoading ? texts.showing : texts.view}
                    </Button>
                </Flex>
            );
        }

        const unitText = unit?.value ? `/${unit?.value}` : '';

        if (!filteredList.length || !Object.keys(filteredList[0]).length) return <>{'-'}</>;

        return (
            <Flex
                componentClasses={styles.inventoryInfoBox}
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                wrap={false}
            >
                {filteredList?.map(item => {
                    return (
                        <Flex
                            key={item.columnName + partName}
                            direction="column"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                        >
                            <Text wrap={false} skin="label-2" textColor="secondary-400">
                                {item.columnTitle}
                            </Text>
                            {filteredList?.length < 3 ? (
                                <Flex justifyContent="flex-start">
                                    <Title
                                        style={{direction: 'ltr'}}
                                        textColor="primary-700"
                                        skin="h4"
                                    >
                                        {item.value}
                                    </Title>
                                    <Title textColor="primary-700" skin="h4">
                                        {unitText}
                                    </Title>
                                </Flex>
                            ) : (
                                <Text
                                    style={{direction: 'ltr'}}
                                    skin="paragraph-2"
                                    textColor="primary-700"
                                >
                                    {item.value + unitText}
                                </Text>
                            )}
                        </Flex>
                    );
                })}
            </Flex>
        );
    }
);
